export default __webpack_public_path__ + "static/media/bishop-thumb.218e0c02.png";